import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const Loader = (props) => {
    const { noMargin } = props

    //@TODO, already defined, fix this duplication later on
    const primaryGreen = '#45908D'
    const secondaryGreen = '#BFE7E0'

    // Damn you tailwind
    const customStyle = {
        borderColor: `${primaryGreen} ${primaryGreen} ${secondaryGreen} ${secondaryGreen}`,
    }

    const classes = classNames('flex justify-center align-center w-full', {
        'mt-10': !noMargin,
    })

    return (
        <div className={classes}>
            <div className={'animate-spin h-6 w-6 mx-4'}>
                <div
                    style={customStyle}
                    className={
                        'border-[6px] rounded-full animate-spin h-full w-full'
                    }
                />
            </div>
        </div>
    )
}

Loader.propTypes = {
    noMargin: PropTypes.bool,
}

export default Loader
